import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {}

  closebanner(event) {
    document.querySelector('.blog_bottom-ad').classList.add('hidden');
  }
}
